export const SAVE_PUSH_ID = 'common/skysso/SAVE_PUSH_ID';
export const APPBRIDGE_READY = 'common/skysso/APPBRIDGE_READY';
export const SBA_READY = 'common/skysso/SBA_READY';
export const LOGOUT = 'common/skysso/LOGOUT';
export const LOGIN = 'common/skysso/LOGIN';
export const BIND_SSO_API = 'common/skysso/BIND_SSO_API';
export const BIND_APPBRIDGE = 'common/skysso/BIND_APPBRIDGE';
export const APPBRIDGE_SLEEP = 'common/skysso/APPBRIDGE_SLEEP';
export const GET_LOGIN_STATE = 'common/skysso/GET_LOGIN_STATE';
export const SSO_LOGIN = 'common/skysso/SSO_LOGIN';
export const SSO_REGISTER = 'common/skysso/SSO_REGISTER';
export const SSO_MY_ACCOUNT = 'common/skysso/SSO_MY_ACCOUNT';

const initialState = {
  loggedIn: false,
  loginInitiated: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        loggedIn: true,
        user: action.data.user
      };
    case LOGOUT:
      return {
        ...state,
        loggedIn: false,
        user: undefined
      };
    case SAVE_PUSH_ID:
      return {
        ...state,
        deviceId: action.deviceId
      }
    case APPBRIDGE_READY:
      return {
        ...state,
        appBridgeReady: true
      }
    case SBA_READY:
      return {
        ...state,
        ssoApi: action.sba
      } 
    case SSO_LOGIN:
      return {
        ...state,
        loginInitiated: true
      }   
    default:
      return state;
  }
}

export function setLogin(data) {
  if (data && data.user && data.user.ssoToken) {
    return {
      type: LOGIN,
      data
    };
  }
}

export function login(data) {
  if (data && data.user && data.user.ssoToken) {
    return {
      type: LOGIN,
      data
    };
  }
}

export function logout() {
  return {
    type: LOGOUT
  };
}

export function savePushId(pushId) {
  return {
    type: SAVE_PUSH_ID,
    deviceId: pushId
  };
}

export function appBridgeReady() {
  return {
    type: APPBRIDGE_READY,
    appBridgeReady: true
  }
}

export function sbaReady(sba) {
  return {
    type: SBA_READY,
    sba
  }
}

export function appBridgeSleep() {
  return {
    type: APPBRIDGE_SLEEP
  }
}

export function bindToSSO() {
  return {
    type: BIND_SSO_API
  }
}

export function bindToAppbridge() {
  return {
    type: BIND_APPBRIDGE
  }
}

export function updateLoginState() {
  return {
    type: GET_LOGIN_STATE
  }
}

export function SSOLogin() {
  return {
    type: SSO_LOGIN
  }
}

export function SSORegister() {
  return {
    type: SSO_REGISTER
  }
}

export function SSOMyAccount() {
  return {
    type: SSO_MY_ACCOUNT
  }
}


// WEBPACK FOOTER //
// ./modules/Common/reducers/skysso.js